import PdfString from './PdfString';

export default class PdfHexString extends PdfString {
  toString(): string {
    return `<${this.valueOf()}>`;
  }
}
